import { render } from "./Cardiology.vue?vue&type=template&id=3d33eb4f&scoped=true"
import script from "./Cardiology.vue?vue&type=script&lang=ts"
export * from "./Cardiology.vue?vue&type=script&lang=ts"

import "./Cardiology.vue?vue&type=style&index=0&id=3d33eb4f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3d33eb4f"

export default script